import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';

import Container from "landing-page/components/common/Container";
import SectionImage from 'landing-page/assets/img/alumni-section.png';
import { CTAProps } from './types';

import styles from './CTA.module.scss';

const CTA: React.FC<CTAProps> = ({
  headline = "Jadi Bagian dari Cerita Inspiratif Alumni LPDP!",
  description = "Tunjukkan perjalanan, prestasi, dan kontribusi Anda untuk menginspirasi generasi berikutnya.",
  buttonText = "Ajukan Profil Sekarang",
  instructionText = "Isi form online & unggah foto Anda.",
  onButtonClick,
  className,
  compact = false,
  gradient = "linear-gradient(135deg, #FF6B35 0%, #FFA500 100%)",
  disabled = false,
  loading = false
}) => {
  const navigate = useNavigate()

  const handleButtonClick = () => {
    if (!disabled && !loading) {
      navigate('/ajukan-profil')
    }
  }

  return (
    <Container className={clsx(styles.ctaSection, className)}>
      <div 
        className={clsx(
          styles.ctaBanner,
          compact && styles.compact
        )}
        style={{
          '--gradient': gradient
        } as React.CSSProperties}
      >
        {/* Left Section - Content */}
        <div className={styles.ctaContent}>
          <div className={styles.ctaHeadline}>
            <i className={clsx("fas fa-star", styles.ctaStarIcon)}></i>
            <span>{headline}</span>
          </div>
          
          <p className={styles.ctaDescription}>
            {description}
          </p>
          
          <Button
            variant="light-orange"
            size="lg"
            className={clsx(styles.ctaButton, "text-primary hover-light-orange")}
            onClick={handleButtonClick}
            disabled={disabled || loading}
          >
            {loading ? (
              <div className="spinner-border spinner-border-sm me-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <i className="fas fa-user-plus me-2 text-primary"></i>
            )}
            {buttonText}
          </Button>
          
          <p className={styles.ctaInstruction}>
            {instructionText}
          </p>
        </div>

        {/* Right Section - People Images */}
        <div className={styles.ctaPeople}>
          <div className={styles.ctaImageContainer}>
            <div className={styles.ctaImageWrapper}>
              <div className={styles.ctaImagePlaceholder}>
                <img 
                  src={SectionImage} 
                  alt="Three people smiling"
                  className={styles.ctaPeopleImage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CTA;